import { render } from "./AguardandoLiberacao.vue?vue&type=template&id=4a5db78c"
import script from "./AguardandoLiberacao.vue?vue&type=script&lang=js"
export * from "./AguardandoLiberacao.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__